module.exports = __WEBPACK_EXTERNAL_MODULE_cb_components_suitability__;